import { zl } from '../../../functions/utilities';

const MieszkaniecStawkiWoda = props => {

    const { wodaMsc, procent } = props;
    
    return (
        <li>
            <div>
                { wodaMsc?.opis }
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div>
                { zl(procent?.saldo) }
            </div>
        </li>
    )

}

export default MieszkaniecStawkiWoda;